import has from 'lodash/has';
import { createSelector } from 'reselect';
import { FLOW_METRICS_INTERVAL_LATEST_RUN } from '../../constants/metricsConstants';
import {
  RESOURCE_TYPE_SOURCE,
  RESOURCE_TYPE_SINK,
  RESOURCE_TYPE_DATA_SET,
} from '../../constants/resourceTypes';
import { getCurrentUser } from '../session';
import isNil from 'lodash/isNil';

const getUserMetrics = (state) => state.metrics.user;
const getOrgMetrics = (state) => state.metrics.org;

export const getFlowMetricsInterval = (state) =>
  state.metrics.flowMetricsInterval ?? FLOW_METRICS_INTERVAL_LATEST_RUN;

export const getUserAccountMetrics = createSelector(
  [getCurrentUser, getUserMetrics],
  (currentUser, userMetrics) => {
    if (has(userMetrics, currentUser.id)) {
      return userMetrics[currentUser.id];
    } else {
      return null;
    }
  },
);

export const getOrgAccountMetrics = createSelector(
  [getCurrentUser, getOrgMetrics],
  (currentUser, orgMetrics) => {
    let orgId = null;

    if (currentUser) {
      orgId = has(currentUser, 'org')
        ? currentUser.org
        : has(currentUser, 'default_org')
          ? currentUser.default_org
          : null;
    }

    if (orgId && has(orgMetrics, orgId)) {
      return orgMetrics[orgId];
    } else {
      return null;
    }
  },
);

/* Source Metrics */
const getMetricsFromSourceId = (state, ownProps) => {
  //TODO: improve memoization
  const { data, cardData } = ownProps;
  const resourceMetrics = state.metrics[RESOURCE_TYPE_SOURCE];
  let resourceId = !isNil(data) ? data.id : !isNil(cardData) ? cardData.id : null;

  return resourceId && has(resourceMetrics, resourceId) ? resourceMetrics[resourceId] : null;
};

export const getMetricsForSource = createSelector(getMetricsFromSourceId, (metrics) => {
  return metrics;
});

const getMetricsFromDataSetId = (state, ownProps) => {
  const { data, cardData } = ownProps;
  let resourceId = !isNil(data) ? data.id : !isNil(cardData) ? cardData.id : null;
  const dataSetMetrics = state.metrics[RESOURCE_TYPE_DATA_SET];

  return resourceId && has(dataSetMetrics, resourceId) ? dataSetMetrics[resourceId] : null;
};

export const getMetricsForDataSet = createSelector(getMetricsFromDataSetId, (metrics) => {
  return metrics;
});

const getMetricsFromSinkId = (state, ownProps) => {
  const { data, cardData } = ownProps;
  let resourceId = !isNil(data) ? data.id : !isNil(cardData) ? cardData.id : null;
  const sinkMetrics = state.metrics[RESOURCE_TYPE_SINK];
  return resourceId && has(sinkMetrics, resourceId) ? sinkMetrics[resourceId] : null;
};

export const getMetricsForSink = createSelector(getMetricsFromSinkId, (metrics) => {
  return metrics;
});

/* Dashboard Metrics */
/* Source Dashboard*/
const getDashboardMetricsFromSourceId = (state, ownProps) => {
  //TODO: improve memoization
  const { data, cardData } = ownProps;
  const hasDashboardMetrics =
    has(state.metrics.dashboard, 'lastUpdated') && state.metrics.dashboard.lastUpdated
      ? true
      : false;

  if (!hasDashboardMetrics) {
    return null;
  }

  const resourceMetrics = state.metrics.dashboard[RESOURCE_TYPE_SOURCE];
  let resourceId = !isNil(data) ? data.id : !isNil(cardData) ? cardData.id : null;

  return resourceId && has(resourceMetrics, resourceId)
    ? resourceMetrics[resourceId]
    : { records: 0, errors: 0, size: 0 };
};

export const getDashboardMetricsForSource = createSelector(
  getDashboardMetricsFromSourceId,
  (metrics) => {
    return metrics;
  },
);

/* Nexset Dashboard*/
const getDashboardMetricsFromDataSetId = (state, ownProps) => {
  const { data, cardData } = ownProps;
  const hasDashboardMetrics =
    has(state.metrics.dashboard, 'lastUpdated') && state.metrics.dashboard.lastUpdated
      ? true
      : false;

  if (!hasDashboardMetrics) {
    return null;
  }

  let resourceId = !isNil(data) ? data.id : !isNil(cardData) ? cardData.id : null;

  const dataSetMetrics = state.metrics.dashboard[RESOURCE_TYPE_DATA_SET];

  return resourceId && has(dataSetMetrics, resourceId)
    ? dataSetMetrics[resourceId]
    : { records: 0, errors: 0, size: 0 };
};

export const getDashboardMetricsForDataSet = createSelector(
  getDashboardMetricsFromDataSetId,
  (metrics) => {
    return metrics;
  },
);

/* Sink Dashboard */
const getDashboardMetricsFromSinkId = (state, ownProps) => {
  const { data, cardData } = ownProps;

  const hasDashboardMetrics =
    has(state.metrics.dashboard, 'lastUpdated') && state.metrics.dashboard.lastUpdated
      ? true
      : false;

  if (!hasDashboardMetrics) {
    return null;
  }

  let resourceId = !isNil(data) ? data.id : !isNil(cardData) ? cardData.id : null;
  const sinkMetrics = state.metrics.dashboard[RESOURCE_TYPE_SINK];
  return resourceId && has(sinkMetrics, resourceId)
    ? sinkMetrics[resourceId]
    : { records: 0, errors: 0, size: 0 };
};

export const getDashboardMetricsForSink = createSelector(
  getDashboardMetricsFromSinkId,
  (metrics) => {
    return metrics;
  },
);
